// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormField_form_box__2K0um.FormField_invalid__1YzJT {\n  color: red !important; }\n  .FormField_form_box__2K0um.FormField_invalid__1YzJT input {\n    border-color: red !important; }\n  .FormField_form_box__2K0um.FormField_invalid__1YzJT .css-1wmd1a2-control {\n    border-color: red !important; }\n\n.FormField_form_validation_wrapper__Lyk91 > span {\n  font-size: 14px !important; }\n", ""]);
// Exports
exports.locals = {
	"form_box": "FormField_form_box__2K0um",
	"invalid": "FormField_invalid__1YzJT",
	"form_validation_wrapper": "FormField_form_validation_wrapper__Lyk91"
};
module.exports = exports;
